"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const SpeedcubingHistoryIcon = createIcon({
  displayName: "SpeedcubingHistoryIcon",
  viewBox: "0 0 41 45",
  path: (
    <>
      <path
        d="M18.22,39.21v-15.41l-13.67-7.82v15.41l13.67,7.82ZM22.78,39.21l13.67-7.82v-15.41l-13.67,7.82v15.41ZM20.5,19.91l13.5-7.71-13.5-7.71-13.5,7.71,13.5,7.71ZM2.28,35.33c-.72-.41-1.28-.96-1.68-1.63-.4-.67-.6-1.42-.6-2.25V13.56c0-.82.2-1.57.6-2.25.4-.68.96-1.22,1.68-1.63L18.22.62c.72-.41,1.48-.62,2.28-.62s1.56.21,2.28.62l15.94,9.06c.72.41,1.28.96,1.68,1.63.4.68.6,1.43.6,2.25v17.89c0,.82-.2,1.57-.6,2.25-.4.67-.96,1.22-1.68,1.63l-15.94,9.06c-.72.41-1.48.62-2.28.62s-1.56-.21-2.28-.62l-15.94-9.06Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default SpeedcubingHistoryIcon;
